export const isMeicaiMallHarmony = () => {
  const ua = navigator.userAgent.toLowerCase()
  return ua.match(/meicaiMallHarmony/i)?.[0] === 'meicaiMallHarmony'
}
export const isHarmony = () => {
  const ua = navigator.userAgent.toLowerCase()
  return ua.match(/harmony/i)?.[0] === 'harmony'
}

export const meicaiMallHarmonyInfo = {
  platform: 3
}
